import { KeyValue } from '@angular/common';

export const ShiftTypeOptions: Array<KeyValue<number, string>> = [
    { key: 1, value: 'Day' },
    { key: 3, value: 'Night' },
    { key: 2, value: 'Mid' }
];

export const ShiftNumberOptions: Array<KeyValue<number, string>> = [
    { key: 3, value: '3' },
    { key: 4, value: '4' },
    { key: 5, value: '5' },
    { key: 6, value: '6' },
    { key: 7, value: '7' }
];

export const ShiftDurationOptions: Array<KeyValue<number, string>> = [
    { key: 4, value: '4 Hrs' },
    { key: 5, value: '5 Hrs' },
    { key: 6, value: '6 Hrs' },
    { key: 7, value: '7 Hrs' },
    { key: 7.5, value: '7.5 Hrs' },
    { key: 8, value: '8 Hrs' },
    { key: 9, value: '9 Hrs' },
    { key: 9.5, value: '9.5 Hrs' },
    { key: 10, value: '10 Hrs' },
    { key: 11, value: '11 Hrs' },
    { key: 11.5, value: '11.5 Hrs' },
    { key: 12, value: '12 Hrs' },
    { key: 13, value: '13 Hrs' },
    { key: 16, value: '16 Hrs' },
    { key: 24, value: '24 Hrs' }
];
